import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import { rechtlichesData } from '@/data/mock';
import { renderWithPlaceholders } from '@/components/pages/renderWithPlaceholders';

const RechtlicheHinweiseView = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0d1a0d] via-[#1a2e1a] to-[#0d1a0d] px-5 py-8 md:p-16 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C9A961]/5 rounded-full blur-3xl" />

      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12 md:mb-20"
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-16 md:w-20 h-px bg-gradient-to-r from-transparent to-[#D4AF37]" />
            <FileText className="w-6 h-6 text-[#D4AF37]" />
            <div className="w-16 md:w-20 h-px bg-gradient-to-l from-transparent to-[#D4AF37]" />
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-light text-white mb-6 tracking-tight" style={{ fontFamily: "'Cormorant', serif" }}>
            {rechtlichesData.title}
          </h1>
          <div className="h-px w-24 md:w-32 mx-auto bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
        </motion.div>

        <div className="space-y-6 md:space-y-8">
          {rechtlichesData.sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 + index * 0.08 }}
              className="luxury-card luxury-blur rounded-2xl p-6 md:p-10 border border-[#D4AF37]/20"
            >
              <h2 className="text-xl md:text-2xl font-light text-white mb-4" style={{ fontFamily: "'Cormorant', serif" }}>
                {section.title}
              </h2>
              <div className="h-px w-16 mb-6 bg-gradient-to-r from-[#D4AF37] to-transparent" />
              <p className="text-white/75 text-sm md:text-base leading-relaxed font-light">
                {renderWithPlaceholders(section.content)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RechtlicheHinweiseView;
